import React, { useEffect, useState } from "react";
import "./App.css";
import Login from "./Login";
import AdminUserManager from "./AdminUserManager";
import AccountInfo from "./AccountInfo";

function App() {
  const [time, setTime] = useState(new Date());
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState("diemdanh"); // "diemdanh" hoặc "taikhoan"

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    // Kiểm tra token khi load lại trang
    const token = localStorage.getItem("token");
    if (token) {
      fetch("https://api.diemdanhkhucgk88.com/api/profile", {
        headers: { Authorization: "Bearer " + token },
      })
        .then(res => res.json())
        .then(data => {
          if (data.username) setUser(data);
          else setUser(null);
        })
        .catch(() => setUser(null));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    setUser(null);
  };

  if (!user) return <Login onLogin={(username, name, role) => setUser({ username, name, role })} />;

  const formatTime = (date) =>
    date.toLocaleTimeString("vi-VN", { hour12: false });

  const formatDate = (date) =>
    date.toLocaleDateString("vi-VN").split("/").reverse().join("-");

  return (
    <div className="container">
      <div className="sidebar">
        <img src="/LOGONEWPEI.png" alt="Logo" className="logo" />
        <ul>
          
          <li
            className={activeTab === "diemdanh" ? "active" : ""}
            onClick={() => setActiveTab("diemdanh")}
          >
            Điểm danh
          </li>
          {user.role === "admin" && (
            <li
              className={activeTab === "taikhoan" ? "active" : ""}
              onClick={() => setActiveTab("taikhoan")}
            >
              Tài khoản
            </li>
          )}
          <li className="logout" onClick={handleLogout}>Đăng xuất</li>
        </ul>
      </div>
      <div className="main">
        <div className="greeting">
          Xin chào: {user.name}
        </div>
        {activeTab === "diemdanh" && (
          <div className="attendance-box">
            <h1>ĐIỂM DANH KHU C - GK88</h1>
            <div className="clock">{formatTime(time)}</div>
            <div className="date">{formatDate(time)}</div>
          </div>
        )}
        {activeTab === "taikhoan" && user.role === "admin" && (
          <AdminUserManager token={localStorage.getItem("token")} />
        )}
      </div>
    </div>
  );
}

export default App;
